import * as yup from "yup";

const textSchema = yup.string()
  .required("Este campo es obligatorio")
  .default("");

export default textSchema;
